import type { paths } from '@src/types/api'

// Fixed list for now. Keep in sync with server-side validated values.
export const DOCUMENT_CATEGORIES = [
  'Risk assessments',
  'Hazard assessments',
  'Adaptation plans',
  'Lived experiences',
  'Operating procedures',
  'Government guidance',
  'Resilience Explorer® methodologies',
] as const

export type GeoreferenceType = 'NONE' | 'POINT' | 'POLYGON'

export type DocumentVisibility = 'organisation' | 'personal'

export type ApiDocument =
  paths['/evidence/documents']['get']['responses'][200]['content']['application/json']['documents'][number]

export interface DocumentGeoreference {
  type: GeoreferenceType
  geometry: ApiDocument['geometry']
  searchLabel?: string | null
}

export interface DocumentFile {
  originalFilename: string
  mimeType: string
  sizeBytes: number
}

export interface EvidenceDocument {
  id: string
  title: string
  descriptionMd: string | null
  category: (typeof DOCUMENT_CATEGORIES)[number]
  ownerId: string
  ownerEmail: string | null
  source: string | null
  organisation: string | null
  publishedAt: string | null
  uploadedAt: string
  notesMd: string | null
  tags: string[]
  georeference: DocumentGeoreference
  visibility: DocumentVisibility
  file: DocumentFile
}

export type DocumentColumnKey =
  | 'category'
  | 'documentType'
  | 'dateUploaded'
  | 'owner'
  | 'tags'
  | 'source'
  | 'datePublished'
  | 'organisation'
  | 'fileSize'
  | 'georeferenced'
  | 'permissions'

export type FileSizeBand = 'any' | 'under1mb' | '1to10mb' | '10to100mb' | 'over100mb'

export type DocumentsSortField = 'title' | 'category' | 'created_at' | 'published_at' | 'size_bytes'

export interface DocumentsSort {
  field: DocumentsSortField
  direction: 'asc' | 'desc'
}

export interface DocumentsFilters {
  search: string
  category: string
  tags: string[]
  organisation: string
  source: string
  visibility: DocumentVisibility | 'all'
  georeferencedOnly: boolean
  fileSizeBand: FileSizeBand
  uploadedFrom: string | null
  uploadedTo: string | null
  publishedFrom: string | null
  publishedTo: string | null
}

export interface DocumentsQuery extends DocumentsFilters {
  page: number
  pageSize: number
  sort: DocumentsSort
}

export interface TagFacet {
  tag: string
  count: number
}

export interface DocumentsListResponse {
  total_count: number
  page_count: number
  documents: EvidenceDocument[]
  tags: TagFacet[]
}
